import { render, staticRenderFns } from "./Producttype.vue?vue&type=template&id=7718bda0&scoped=true&"
import script from "./Producttype.vue?vue&type=script&lang=js&"
export * from "./Producttype.vue?vue&type=script&lang=js&"
import style0 from "./Producttype.vue?vue&type=style&index=0&id=7718bda0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7718bda0",
  null
  
)

export default component.exports